// extracted by mini-css-extract-plugin
export var active = "_2c-7";
export var backButton = "_2c-6";
export var clone = "_2c-c";
export var collapseBar = "_2c-g";
export var collapseMode = "_2c-i";
export var dragHandle = "_2c-a";
export var dropdownIcon = "_2c-e";
export var hidden = "_2c-o";
export var iconContainer = "_2c-l";
export var iconSwapper = "_2c-n";
export var navItem = "_2c-4";
export var navItemIcon = "_2c-d";
export var navProfile = "_2c-5";
export var notificationDot = "_2c-m";
export var optionsContainer = "_2c-f";
export var primaryNav = "_2c-0";
export var primaryTab = "_2c-j";
export var secondaryNav = "_2c-1";
export var selected = "_2c-k";
export var settingsNav = "_2c-2";
export var settingsNavItems = "_2c-3";
export var show = "_2c-b";
export var sideNav = "_2c-h";
export var teamItem = "_2c-8";
export var userProfileItem = "_2c-9";